/* eslint-disable no-console */
import type { Action } from 'src/types';

import { browserLogError, type BrowserLogExtras } from './browserLog';

declare global {
  interface Window {
    TrackJS: {
      track: (error: Error) => void;
      configure: (params: { userId: string }) => void;
    };
  }
}

const shouldTrack = () =>
  typeof window !== 'undefined' &&
  window.TrackJS &&
  window.APP_CONFIG &&
  window.APP_CONFIG.TRACKJS_ENABLED;

export const log = (error: Error, browserLogExtras?: BrowserLogExtras) => {
  if (shouldTrack()) {
    window.TrackJS.track(error);
  } else {
    console.error(error);
  }
  browserLogError(error, browserLogExtras);
};

export const logInfo = (info: any) => {
  console.log(info);
};

export const configureTrackJs = (id: string) => {
  if (shouldTrack()) {
    window.TrackJS.configure({
      userId: id,
    });
  }
};

export const middlewareErrorLogger =
  () => () => (next: (action: Action) => void) => (action: Action) => {
    try {
      if (shouldTrack()) {
        console.log(action.type); // Log action names to the TrackJS telemetry timeline so actions before the error are recorded
      }
      return next(action);
    } catch (err) {
      if (shouldTrack()) {
        console.warn(action.type); // Log the error to the timeline
      }
      log(err as Error, {
        name: action.type,
        kind: 'MiddlewareError',
      });
    }
  };
